"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var axios_1 = __importDefault(require("axios"));
var req_1 = __importDefault(require("./req"));
function not(arg) {
    if (typeof arg === 'function') {
        return function (value) { return !arg(value); };
    }
    return !arg;
}
function isNil(value) {
    return value === undefined || value === null;
}
function isValidInputObject(obj) {
    return Object.keys(obj).length > 1;
}
function uploadFileReducer(state, action) {
    switch (action.type) {
        case 'REGISTER': {
            var newState = state.filter(isValidInputObject);
            return __spreadArrays(newState, [{}]);
        }
        case 'UNREGISTER': {
            var _a = state[action.payload] || {}, request = _a.request, done = _a.done, uploadUrl = _a.uploadUrl;
            if (!request && !uploadUrl) {
                // do nothing
                return state;
            }
            if (request && !done) {
                request.cancel();
                return state.filter(function (_, index) { return index !== action.payload; });
            }
            if (request && done) {
                var newFiles = __spreadArrays(state);
                newFiles[action.payload].request.cancelled = true;
                return newFiles;
            }
            return state.filter(function (_, index) { return index !== action.payload; });
        }
        case 'DELETE': {
            return state.filter(function (_, index) { return index !== action.payload; });
        }
        case 'TARGET': {
            var _b = action.payload, ref = _b.ref, index = _b.index;
            if (ref && !state[index].ref) {
                ref.click();
                var newFiles = __spreadArrays(state);
                newFiles[index].ref = ref;
                return newFiles;
            }
            return state;
        }
        case 'UPDATE': {
            var _c = action.payload, index = _c.index, valid = _c.valid, error = _c.error, file = _c.file, uploadUrl = _c.uploadUrl;
            var newFiles = __spreadArrays(state);
            newFiles[index].file = file;
            newFiles[index].uploadUrl = uploadUrl;
            newFiles[index].valid = valid;
            newFiles[index].error = error;
            newFiles[index].progress = 0;
            newFiles[index].done = false;
            newFiles[index].failed = false;
            return newFiles;
        }
        case 'UPDATE_DATA': {
            var _d = action.payload, index_1 = _d.index, props_1 = _d.props;
            return state.map(function (uploadData, currentIndex) {
                if (currentIndex === index_1) {
                    return __assign(__assign({}, uploadData), { data: __assign(__assign({}, uploadData.data), props_1) });
                }
                return uploadData;
            });
        }
        case 'START': {
            var _e = action.payload, request = _e.request, index = _e.index;
            var newFiles = __spreadArrays(state);
            if (!newFiles[index]) {
                return state;
            }
            newFiles[index].request = request;
            newFiles[index].request.cancelled = false;
            return newFiles;
        }
        case 'PROGRESS': {
            var _f = action.payload, progress = _f.progress, index = _f.index;
            var newFiles = __spreadArrays(state);
            if (!newFiles[index]) {
                return state;
            }
            newFiles[index].progress = progress;
            return newFiles;
        }
        case 'FAILURE': {
            var _g = action.payload, error = _g.error, index = _g.index;
            var newFiles = __spreadArrays(state);
            if (!newFiles[index]) {
                return state;
            }
            newFiles[index].error = error;
            newFiles[index].failed = true;
            return newFiles;
        }
        case 'RETRY': {
            var newFiles = __spreadArrays(state);
            newFiles[action.payload].request = undefined;
            newFiles[action.payload].error = undefined;
            newFiles[action.payload].failed = false;
            newFiles[action.payload].done = false;
            newFiles[action.payload].progress = 0;
            return newFiles;
        }
        case 'UPDATE_LINK': {
            var _h = action.payload, uploadUrl = _h.uploadUrl, data = _h.data, index = _h.index;
            var newFiles = __spreadArrays(state);
            if (!newFiles[index]) {
                return state;
            }
            newFiles[index].data = data;
            newFiles[index].uploadUrl = uploadUrl;
            return newFiles;
        }
        case 'FINISH': {
            var index = action.payload.index;
            var newFiles = __spreadArrays(state);
            if (!newFiles[index]) {
                return state;
            }
            newFiles[index].done = true;
            return newFiles;
        }
        default: {
            return state;
        }
    }
}
function usePresignedUpload(options) {
    var accept = options.accept, fileSize = options.fileSize, onChange = options.onChange;
    var _a = react_1.useReducer(function (state, action) { return uploadFileReducer(state, action); }, []), uploads = _a[0], dispatch = _a[1];
    var requestUploadUrl = function (uploadItem, index) {
        req_1.default
            .get('/storage/upload-link', {
            params: {
                path: options.path,
                fileName: uploadItem.file.name,
            },
        })
            .then(function (_a) {
            var link = _a.link, path = _a.path, originalFilename = _a.originalFilename, filename = _a.filename;
            dispatch({
                type: 'UPDATE_LINK',
                payload: {
                    index: index,
                    data: {
                        filename: filename,
                        path: path,
                        tipo: uploadItem.file.type,
                        originalFilename: originalFilename,
                    },
                    uploadUrl: link,
                },
            });
        })
            .catch(function () {
            dispatch({
                type: 'FAILURE',
                payload: { index: index, error: 'Falha no upload do arquivo. Tente novamente.' },
            });
        });
    };
    var makeUpload = function (upload, index) {
        var CancelToken = axios_1.default.CancelToken;
        var source = CancelToken.source();
        var request = axios_1.default.put(upload.uploadUrl, upload.file, {
            cancelToken: source.token,
            onUploadProgress: function (progressEvent) {
                var progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                dispatch({ type: 'PROGRESS', payload: { index: index, progress: progress } });
            },
        });
        request.then(function () {
            dispatch({ type: 'FINISH', payload: { index: index } });
        });
        request.catch(function (error) {
            if (!axios_1.default.isCancel(error)) {
                dispatch({
                    type: 'FAILURE',
                    payload: { index: index, error: 'Falha no upload do arquivo. Tente novamente.' },
                });
            }
        });
        dispatch({
            type: 'START',
            payload: {
                index: index,
                request: {
                    promise: request,
                    cancel: function () {
                        source.cancel('Operation canceled by the user.');
                    },
                    cancelled: false,
                },
            },
        });
    };
    var isFormatValid = function (file) { return accept.length === 0 || accept.includes(file.type); };
    var isSizeValid = function (file) { return fileSize === 0 || file.size / (1024 * 1024) <= fileSize; };
    react_1.useEffect(function () {
        uploads.forEach(function (upload, index) {
            var _a;
            if (!upload.request && upload.file && upload.valid) {
                if (upload.uploadUrl) {
                    makeUpload(upload, index);
                }
                else {
                    requestUploadUrl(upload, index);
                }
            }
            if ((_a = upload.request) === null || _a === void 0 ? void 0 : _a.cancelled) {
                dispatch({
                    type: 'DELETE',
                    payload: index,
                });
            }
        });
    }, [uploads]);
    react_1.useEffect(function () {
        var newUploads = uploads.filter(isValidInputObject);
        var done = newUploads.every(function (upload) { return upload.done; });
        var valid = newUploads.every(function (upload) { return upload.valid; });
        var value = newUploads.map(function (_a) {
            var data = _a.data;
            return data;
        }).filter(not(isNil));
        var hasError = newUploads.some(function (upload) { return upload.error; });
        onChange === null || onChange === void 0 ? void 0 : onChange(value, { valid: valid, done: done, empty: newUploads.length === 0, hasError: hasError });
    }, [uploads]);
    return {
        uploads: uploads,
        add: function () {
            dispatch({ type: 'REGISTER' });
        },
        cancel: function (index) {
            dispatch({ type: 'UNREGISTER', payload: index });
        },
        deleteFile: function (index) {
            var file = uploads[index];
            if (file.done || !file.valid) {
                dispatch({ type: 'DELETE', payload: index });
            }
            else {
                dispatch({ type: 'UNREGISTER', payload: index });
            }
        },
        retry: function (index) {
            dispatch({ type: 'RETRY', payload: index });
        },
        loadInput: function (index) {
            return function (ref) {
                dispatch({ type: 'TARGET', payload: { index: index, ref: ref } });
            };
        },
        updateData: function (index, props) {
            dispatch({
                type: 'UPDATE_DATA',
                payload: { index: index, props: props },
            });
        },
        handleInput: function (index) {
            return function (event) {
                var _a;
                var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a.item(0);
                var isDuplicated = uploads.find(function (upload) { var _a, _b; return ((_a = upload === null || upload === void 0 ? void 0 : upload.file) === null || _a === void 0 ? void 0 : _a.name) === (file === null || file === void 0 ? void 0 : file.name) && ((_b = upload === null || upload === void 0 ? void 0 : upload.file) === null || _b === void 0 ? void 0 : _b.size) === (file === null || file === void 0 ? void 0 : file.size); });
                if (!file || isDuplicated) {
                    dispatch({ type: 'UNREGISTER', payload: index });
                    return;
                }
                var valid = true;
                var error;
                if (!isFormatValid(file)) {
                    valid = false;
                    error = 'Formato não aceito';
                }
                else if (!isSizeValid(file)) {
                    valid = false;
                    error = "Arquivo maior do que " + fileSize + "mb";
                }
                dispatch({
                    type: 'UPDATE',
                    payload: { index: index, file: file, valid: valid, error: error },
                });
            };
        },
    };
}
exports.default = usePresignedUpload;
